import TagsRegisterView from '@Tags/views/TagsRegister.vue';
import MainTagsPage from '@Tags/views/index.vue';

export default [
  {
    path: '/:id/tags-registers/:registerId',
    component: MainTagsPage,
    meta: {
      requiresAuth: true,
      facilityScope: true,
      layout: 'viewer-layout',
    },
    children: [
      {
        path: '',
        name: 'tags-register',
        component: TagsRegisterView,
        meta: {
          requiresAuth: true,
          title: 'Tag Register',
          layout: 'viewer-layout',
        },
      },
    ],
  },
];
